/* Publish by EComposer at 2024-06-05 08:50:37*/
(function(){
    const Func = (function() {
        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tihmi9dpwa"]=  window.__ectimmers["ecom-tihmi9dpwa"] || {};
if(!this.$el)return;const e=this.$el,t=e.querySelector(".ecom-text_view-more-btn"),i=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(t&&t.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",t.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",t.style.display=""}))

    });
    
        document.querySelectorAll('.ecom-tihmi9dpwa').forEach(function(el){
            Func.call({$el: el, id: 'ecom-tihmi9dpwa', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-4bcsyex5gun').forEach(function(el){
            Func.call({$el: el, id: 'ecom-4bcsyex5gun', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-nvfytnil1qo').forEach(function(el){
            Func.call({$el: el, id: 'ecom-nvfytnil1qo', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-x1t9s8y7zlo').forEach(function(el){
            Func.call({$el: el, id: 'ecom-x1t9s8y7zlo', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-gj50f4ccc3').forEach(function(el){
            Func.call({$el: el, id: 'ecom-gj50f4ccc3', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-89uqf1f4pmf').forEach(function(el){
            Func.call({$el: el, id: 'ecom-89uqf1f4pmf', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-csuksuuwy3t').forEach(function(el){
            Func.call({$el: el, id: 'ecom-csuksuuwy3t', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-xgvbokn3fz9').forEach(function(el){
            Func.call({$el: el, id: 'ecom-xgvbokn3fz9', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-3n6g914jds2').forEach(function(el){
            Func.call({$el: el, id: 'ecom-3n6g914jds2', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-n7pk6bvkq9k').forEach(function(el){
            Func.call({$el: el, id: 'ecom-n7pk6bvkq9k', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-yysa4pfdigd').forEach(function(el){
            Func.call({$el: el, id: 'ecom-yysa4pfdigd', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-df5slgmax3').forEach(function(el){
            Func.call({$el: el, id: 'ecom-df5slgmax3', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-o8ljnsjbk7h').forEach(function(el){
            Func.call({$el: el, id: 'ecom-o8ljnsjbk7h', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-aeld32e5f6').forEach(function(el){
            Func.call({$el: el, id: 'ecom-aeld32e5f6', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-2d4uqpr3lul').forEach(function(el){
            Func.call({$el: el, id: 'ecom-2d4uqpr3lul', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-j23qx0dsubj').forEach(function(el){
            Func.call({$el: el, id: 'ecom-j23qx0dsubj', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-rtpv398jee').forEach(function(el){
            Func.call({$el: el, id: 'ecom-rtpv398jee', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-o6drqx512l').forEach(function(el){
            Func.call({$el: el, id: 'ecom-o6drqx512l', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-i6xfr4xyjp').forEach(function(el){
            Func.call({$el: el, id: 'ecom-i6xfr4xyjp', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-vr06l0r3pw7').forEach(function(el){
            Func.call({$el: el, id: 'ecom-vr06l0r3pw7', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-58iughr3sp6').forEach(function(el){
            Func.call({$el: el, id: 'ecom-58iughr3sp6', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-f9j4vjxv8ag').forEach(function(el){
            Func.call({$el: el, id: 'ecom-f9j4vjxv8ag', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-zk3p30y5kxg').forEach(function(el){
            Func.call({$el: el, id: 'ecom-zk3p30y5kxg', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-jymladord39').forEach(function(el){
            Func.call({$el: el, id: 'ecom-jymladord39', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-qoifgtivjzl').forEach(function(el){
            Func.call({$el: el, id: 'ecom-qoifgtivjzl', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-a1jjd0kwfur').forEach(function(el){
            Func.call({$el: el, id: 'ecom-a1jjd0kwfur', settings: {},isLive: true});
        });
    
        document.querySelectorAll('.ecom-j4i22t4ugsn').forEach(function(el){
            Func.call({$el: el, id: 'ecom-j4i22t4ugsn', settings: {},isLive: true});
        });
    

})();

(function(){
    const Func = (function() {
        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-frziox2pp8m"]=  window.__ectimmers["ecom-frziox2pp8m"] || {};
let e=this.$el;if(!e)return;let t=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;t.forEach((r,a)=>{n==="click"||window.screen.width<1025?r.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(t.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active"))):(t.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),r.classList.add("ecom-item-active"),i[a].classList.add("ecom-item-active")),o()}:r.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(t.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active"))):(t.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),r.classList.add("ecom-item-active"),i[a].classList.add("ecom-item-active")),o()}});function s(){let r=window.location.hash;if(r){let a=e.querySelector(`[data-target="${r}"]`);if(a){a.click();let l=a.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,l)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

    });
    
        document.querySelectorAll('.ecom-frziox2pp8m').forEach(function(el){
            Func.call({$el: el, id: 'ecom-frziox2pp8m', settings: {"action":"click"},isLive: true});
        });
    

})();
